<template>
    <div class="event-item">
        <div v-if="event.type != 'comment'" class="event">
            <div class="event-header w-100 mb-2">
                <icon :name="getEventTypeIcon" color="white" scale="1.3" />
                <div class="d-flex align-items-center h-100 w-100">
                    <p class="text-12 text-weight-bold text-secondary">{{ event.created_by.name }} {{ event.created_by.surname }}</p>
                </div>
                <div class="d-flex align-items-center h-100 w-100">
                    <p class="text-10 text-secondary-3">
                        {{ getFormattedDate(moment, event.created_at) }}
                    </p>
                </div>
            </div>
            <div class="event-body">
                <p class="text-12 text-white mt-2">{{ getEventType }} {{ $t('Components_Issues_Event2_2') }}</p>
            </div>
        </div>
        <div v-else class="comment">
            <div class="comment-header w-100 mb-2">
                <b-avatar :src="event.created_by.image" size="24" />
                <div class="d-flex align-items-center h-100 w-100">
                    <p class="text-12 text-weight-bold text-secondary">{{ event.created_by.name }} {{ event.created_by.surname }}</p>
                </div>
                <div class="d-flex align-items-center h-100 w-100">
                    <p class="text-10 text-secondary-3">
                        {{ getFormattedDate(moment, event.created_at) }}
                    </p>
                </div>
                <div class="d-flex align-items-center h-100 w-100">
                    <div class="icon d-flex align-items-center" v-if="event.created_by.email == loggedUser.email && !isArchived">
                        <button v-if="!edit.status" @click="startEdit()">
                            <icon color="var(--secondary-3)" name="edit" scale="0.8" />
                        </button>
                        <button v-if="!edit.status" @click="deleting = true">
                            <icon color="var(--secondary-3)" name="trash" scale="0.8" />
                        </button>
                        <button v-else @click="cancelEdit()">
                            <icon color="var(--secondary-3)" name="times" scale="0.8" />
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="!deleting">
                <!-- is editing -->
                <div v-if="edit.status" class="comment-body">
                    <textarea ref="edit-input" v-model="edit.comment.text"></textarea>
                    <div v-if="edit.comment.attachments && edit.comment.attachments.length > 0" class="assets mt-3">
                        <FilePreview :showActions="true" :key="file.id" v-for="file in edit.comment.attachments" :file="file" :onRemove="onRemoveAttachment" />
                    </div>
                    <ci-button small :text="$t('keyword17')" @click="save" :loading="edit.loading" class="my-2" />
                </div>
                <!-- not editing -->
                <div v-else class="comment-body">
                    <p class="text-12 text-white mt-2">{{ event.comment.text }}</p>
                    <div v-if="event.comment.attachments && event.comment.attachments.length > 0" class="assets">
                        <AttachmentPreview :attachments="event.comment.attachments" />
                    </div>
                </div>
            </div>
            <div class="confirmation" v-else>
                <p>
                    {{ $t('Components_Issues_Event2_1') }}
                    <br />
                    <br />
                    <a @click="deleteComment()">{{ $t('yes') }}</a>
                    <a @click="deleting = false">{{ $t('no') }}</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue-awesome/icons/exclamation-circle'
import 'vue-awesome/icons/check-circle'
import 'vue-awesome/icons/ellipsis-h'
import 'vue-awesome/icons/edit'
import 'vue-awesome/icons/trash'
import 'vue-awesome/icons/times'

import { mapState } from 'vuex'

import FilePreview from '@/components/Utils/FilePreview'
import AttachmentPreview from '@/components/Utils/AttachmentPreview'

export default {
    components: {
        FilePreview,
        AttachmentPreview,
    },
    props: {
        event: Object,
        loggedUser: {
            type: Object,
            default: () => {
                return {}
            },
        },
        status: String,
    },
    computed: {
        ...mapState(['sidebar']),
        isArchived() {
            return false
        },
        getEventTypeIcon() {
            return this.event.type == 'reopen' ? 'exclamation-circle' : this.event.type == 'to_review' ? 'ci-issue-viewed' : 'check-circle'
        },
        getEventType() {
            return this.event.type == 'reopen' ? this.$t('keyword115') : this.event.type == 'to_review' ? this.$t('keyword116') : this.$t('keyword117')
        },
    },
    data() {
        return {
            deleting: false,
            edit: {
                loading: false,
                status: false,
                comment: {
                    text: null,
                    attachments: [],
                    removedAttachments: [],
                },
            },
        }
    },
    methods: {
        getFormattedDate(moment, date) {
            let diff = moment.duration(moment().diff(moment(date, 'DD/MM/YYYY')))
            let formattedString = ''
            if (diff.years() > 0) {
                let years = diff.years()
                let months = diff.months()
                formattedString +=
                    years +
                    (years > 1 ? this.$t('keyword9') : this.$t('keyword8')) +
                    (months > 0 ? this.$t('keyword12') + months + (months > 1 ? this.$t('keyword7') : this.$t('keyword6')) : '')
            } else if (diff.months() > 0) {
                let months = diff.months()
                let days = diff.days()
                formattedString +=
                    months +
                    (months > 1 ? this.$t('keyword7') : this.$t('keyword6')) +
                    (days > 0 ? this.$t('keyword12') + days + (days > 1 ? this.$t('keyword4') : this.$t('keyword5')) : '')
            } else if (diff.days() > 0) {
                let days = diff.days()
                formattedString += days + (days > 1 ? this.$t('keyword5') : this.$t('keyword4'))
            } else {
                formattedString = this.$t('keyword10') + moment(date, 'DD/MM/YYYY HH:mm').format('HH:mm')
                return formattedString
            }
            return formattedString + this.$t('keyword11')
        },
        save() {
            this.edit.loading = true
            if (this.edit.comment.text) {
                this.edit.loading = false
                this.$emit('onCommentUpdated', {
                    id: Number(this.edit.comment.id),
                    text: this.edit.comment.text,
                })
                this.cancelEdit()
            } else {
                this.edit.loading = false
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: this.$t('Projects_notify_error_title9'),
                    text: this.$t('Projects_notify_error_text12'),
                })
            }
        },
        deleteComment() {
            this.$emit('onCommentDeleted', {
                id: Number(this.event.id),
            })
            this.deleting = false
        },
        onRemoveAttachment(attachment) {
            this.edit.comment.removedAttachments.push(attachment)
            this.edit.comment.attachments.splice(this.edit.comment.attachments.indexOf(attachment), 1)
        },
        cancelEdit() {
            this.edit.status = false
            this.edit.comment.removedAttachments = []
        },
        startEdit() {
            this.edit.comment = Object.assign({}, this.event.comment)
            this.edit.status = true
            this.edit.comment.removedAttachments = []
            setTimeout(() => {
                this.$refs['edit-input'].focus()
            }, 1)
        },
    },
}
</script>

<style lang="scss" scoped>
.event-item {
    padding: 8px 16px;
    border-bottom: 1px solid var(--primary-3);
    margin-bottom: -1px;
    .event {
        .event-header {
            display: grid;
            grid-template-columns: max-content max-content minmax(0, 1fr) max-content;
            column-gap: 8px;
            margin-bottom: 8px;
            p {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                width: 130px;
            }
        }
        .event-body {
            text-align: justify;
            color: white;
            line-height: 1 !important;
            padding-bottom: 3px;
            p {
                white-space: pre-line;
            }
        }
    }
    .comment {
        .comment-header {
            display: grid;
            grid-template-columns: max-content max-content minmax(0, 1fr) max-content;
            column-gap: 8px;
            .icon {
                button {
                    outline: none;
                    border: none;
                    background-color: transparent;
                }
            }
            svg {
                cursor: pointer;
            }
            p {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                width: 120px;
            }
        }
        .comment-body {
            text-align: justify;
            color: white;
            textarea {
                text-align: justify;
                padding-top: 12px;
                padding-bottom: 12px;
                padding-left: 20px;
                color: var(--secondary-3);
                resize: none;
                height: 100%;
                width: 100%;
                background-color: var(--primary-3);
                border: none;
                outline: none;
                border-radius: 4px;
            }
            .assets {
                display: flex;
                flex-wrap: wrap;
                img {
                    height: 300px;
                    width: auto;
                    margin-right: 20px;
                    cursor: pointer;
                }
            }
            p {
                white-space: pre-line;
            }
        }
        .confirmation {
            p {
                color: var(--light);
                font-size: 14px;
                margin-top: 15px;
                a {
                    color: var(--secondary);
                    margin-right: 15px;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
